const sounds = require.context("../assets/sounds", true);

module.exports = sounds;

//http://soundbible.com/918-Bison.html - Public Domain Sound File
